module.exports = __webpack_public_path__ + "img/dataXls2.e68049c5.png";